import { Pipe, PipeTransform } from '@angular/core';
import { NzPresetColor } from 'ng-zorro-antd/core/color';
import {
  faAngleDoubleUp,
  faAngleDown,
  faAngleUp,
  faEquals,
} from '@fortawesome/pro-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

enum MinOvertimeRangeSpecs {
  VeryPositive = 100,
  Positive = 40,
  Medium = -40,
}

@Pipe({
  name: 'overtimeIcon',
  standalone: true,
})
export class OvertimeIconPipe implements PipeTransform {
  transform(overtimeInMinutes: number | null | undefined):
    | {
        color: NzPresetColor;
        name: IconDefinition;
      }
    | undefined {
    if (overtimeInMinutes == null) return;

    const overtimeInHours = overtimeInMinutes / 60;

    if (overtimeInHours >= MinOvertimeRangeSpecs.VeryPositive) {
      return { color: 'volcano', name: faAngleDoubleUp };
    }

    if (overtimeInHours >= MinOvertimeRangeSpecs.Positive) {
      return { color: 'volcano', name: faAngleUp };
    }

    if (overtimeInHours > MinOvertimeRangeSpecs.Medium) {
      return { color: 'gold', name: faEquals };
    }

    return { color: 'blue', name: faAngleDown };
  }
}
